import React from 'react';
import styled from 'styled-components';

export type SortOrder = 'asc' | 'desc';

const TableSortButton = ({
  label,
  active,
  order,
  onClick,
}: {
  label: string;
  active: boolean;
  order: SortOrder;
  onClick: () => void;
}) => (
  <Button
    type="button"
    aria-label={`${label} ${
      active ? (order === 'asc' ? '오름차순' : '내림차순') : ''
    } 정렬`}
    onClick={onClick}>
    {label}
    <span aria-hidden="true">
      {active ? (order === 'asc' ? '▲' : '▼') : '↕'}
    </span>
  </Button>
);

export default TableSortButton;

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100%;
  color: inherit;
  font: inherit;
  font-weight: inherit;
  cursor: pointer;
`;
